import { useState } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import BookCallModal from "../../components/feature/BookCallModal";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import ServicesSectionHome from "./components/ServicesSectionHome";
import IndustriesSectionHome from "./components/IndustriesSectionHome";
import CaseStudySection from "./components/CaseStudySection";
import TestimonialsSection from "./components/TestimonialsSection";
import CTASection from "./components/CTASection";
import AboutSection from "./components/AboutSection";

const Home = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="min-h-screen font-sans">
      <Navbar onBookCall={() => setModalOpen(true)} />
      <main>
        <HeroSection onBookCall={() => setModalOpen(true)} />
        <AboutSection />
        <ProblemSection />
        <SolutionSection />
        <ServicesSectionHome />
        <IndustriesSectionHome />
        <CaseStudySection />
        <TestimonialsSection />
        <CTASection onBookCall={() => setModalOpen(true)} />
      </main>
      <Footer onBookCall={() => setModalOpen(true)} />
      <BookCallModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
};

export default Home;
